<script>
  import {Bar} from "vue-chartjs";

  export default {
    extends: Bar,
    name: 'MonthIncomeChart',
    props: ['orders'],
    data() {
      return {
        groupedOrders: [],
        barChartData: {
          labels: [],
          datasets: [
            {
              backgroundColor: "rgba(255, 205, 86, 0.7)",
              data: [],
              borderColor: "rgba(255, 205, 86)",
              borderWidth: 2,
            }
          ]
        },
        barChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            },
            datalabels: {
              color: 'white',
              anchor: 'end',
              align: 'start',
            },
          }
        }
      }
    },
    methods: {
      groupOrders() {
        //filtering YearToDate orders
        let orders = this.orders;

        //Grouping orders by months (using Order Date)
        let months = []

        function groupItemBy(array, property) {
          var hash = {},
            props = property.split('.');
          for (var i = 0; i < array.length; i++) {
            var key = props.reduce(function (acc, prop) {
              return acc && acc[prop];
            }, array[i]);
            if (!hash[key]) hash[key] = [];
            hash[key].push(array[i]);
          }
          return hash;
        }

        let grouped = Object.values(groupItemBy(orders, 'orderDate'));

        //Adding grouped orders to month array, merging to unique months and sorting values.
        for (let i = 0; i < grouped.length; i++) {
          months.push(new Date(grouped[i][0].orderDate).getMonth())
        }
        const uniqueMonths = [...new Set(months)].sort(function compareNumbers(a, b) {
          return a - b;
        })

        //Converting month digits to String representation
        let uniqueMonthsStrings = []
        for (let i = 0; i < uniqueMonths.length; i++) {
          let b = "";
          switch (i) {
            case 0:
              b = this.$t('months-short.jan');
              uniqueMonthsStrings.push(b)
              break;
            case 1:
              b = this.$t('months-short.feb');
              uniqueMonthsStrings.push(b)
              break;
            case 2:
              b = this.$t('months-short.mar');
              uniqueMonthsStrings.push(b)
              break;
            case 3:
              b = this.$t('months-short.apr');
              uniqueMonthsStrings.push(b)
              break;
            case 4:
              b = this.$t('months-short.may');
              uniqueMonthsStrings.push(b)
              break;
            case 5:
              b = this.$t('months-short.jun');
              uniqueMonthsStrings.push(b)
              break;
            case 6:
              b = this.$t('months-short.jul');
              uniqueMonthsStrings.push(b)
              break;
            case 7:
              b = this.$t('months-short.aug');
              uniqueMonthsStrings.push(b)
              break;
            case 8:
              b = this.$t('months-short.sep');
              uniqueMonthsStrings.push(b)
              break;
            case 9:
              b = this.$t('months-short.oct');
              uniqueMonthsStrings.push(b)
              break;
            case 10:
              b = this.$t('months-short.nov');
              uniqueMonthsStrings.push(b)
              break;
            case 11:
              b = this.$t('months-short.dec');
              uniqueMonthsStrings.push(b)
              break;
          }
        }
        let totalOrdersCost = orders
          .map((order) => order.totalCost)
          .reduce(function (previous, current) {
            return previous + current;
          }, 0).toFixed(0)

        //Getting total cost for each month
        let totalRevenueByMonth = []
        for (let i = 0; i < uniqueMonths.length; i++) {
          totalRevenueByMonth.push((orders.filter(e => new Date(e.orderDate).getMonth() === i)
            .map((order) => order.totalCost)
            .reduce(function (previous, current) {
              return previous + current;
            }, 0) * 100 / totalOrdersCost).toFixed(1))
        }

        //Pushing the calculated data to chart arrays (data/labels separately)
        this.barChartData.datasets[0].data = totalRevenueByMonth
        this.barChartData.labels = uniqueMonthsStrings;
      }
    },
    async mounted() {
      this.groupOrders()
      this.renderChart(this.barChartData, this.barChartOptions);
    },
  };
</script>

<style scoped>

</style>
